import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message-context-menu" }

import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ChatModalMenu"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  },
  emits: ["update:visible"],
  setup(__props) {

let visible = _useModel<boolean>(__props, "visible");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatModalMessage, {
    visible: _unref(visible),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
    "without-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})